import BaseModel from "./_BaseModel";
import Customer from "./Customer";
import Divisi from "./Divisi";
import TerimaBayarTransaksi from "./TerimaBayarTransaksi";

export default class TerimaBayar extends BaseModel {
    public readonly ucode?: string;
    public ucode_divisi?: string;
    public kode_divisi?: string;
    public nama_divisi?: string;
    public divisi?: Divisi;
    public no_transaksi?: string;
    public tanggal_transaksi?: string;
    public ucode_customer?: string;
    public kode_customer?: string;
    public nama_customer?: string;
    public customer?: Customer;
    public grand_total?: number;
    public keterangan?: string;
    public list_terima_bayar_transaksi?: TerimaBayarTransaksi[] = [];
    public is_new?: boolean = true;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
};
